import { useRegisterSW } from "virtual:pwa-register/react";

export function useServiceWorkerUpdate() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      if (import.meta.env.DEV) {
        console.error("Service worker registration failed", error);
      }
    },
  });

  return {
    needRefresh,
    dismissRefresh: () => setNeedRefresh(false),
    applyUpdate: async () => {
      await updateServiceWorker(true);
    },
  };
}
